
































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import Arrow from '@/components/icons/Arrow.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import HeartSolidIcon from '@/components/icons/HeartSolid.vue';
import HeartOutlineIcon from '@/components/icons/HeartOutline.vue';

import { copyToClipboard } from '@/utils';

type TableCardVariant = 'default' | 'outlined';

type Data = {
  headerTitle: string;
  title: string;
  iconTitle?: string;
  avatarUrl: string;
  avatarUrlFallbackText?: string;
  showRightArrow?: boolean;
  footer?: Array<{
    label: string;
    value: string;
  }>;
  list: Array<{
    topic: string;
    description: string;
    theme?: string;
    copyIcon?: boolean;
    copyNotification?: string;
    className?: string;
  }>;
};

@Component({
  components: {
    GhostButton,
    Arrow,
    HeartSolidIcon,
    HeartOutlineIcon
  }
})
export default class TableCard extends Vue {
  @Prop({ default: false }) tableLayoutFixed?: boolean;
  @Prop({ default: 'default' }) variant?: TableCardVariant;
  @Prop({ default: false }) showMoreButton?: boolean;
  @Prop({
    default: () => ({
      headerTitle: '',
      avatarUrl: '',
      title: '',
      iconTitle: '',
      list: [],
      footer: []
    })
  })
  data!: Data;

  onCopy(copy: string, copyNotification: string) {
    copyToClipboard(copy, () => {
      this.$notification(copyNotification ? copyNotification : 'Copied item.');
    });
  }
}
